import {get} from 'utils/axios/index'
import {toast} from 'react-toastify'
import {DefaultApiResponse} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFormField} from 'models/Common'

const fetchLedgerEntries = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/ledger/v1/entries`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const downloadStatement = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<IFormField>(`/ledger/v1/download`, {
   ...payload,
  }).then((res) => {
   if (res?.download_s3_presigned_url) {
    return res?.download_s3_presigned_url
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {fetchLedgerEntries, downloadStatement}
